export default __webpack_public_path__ + "static/media/bse-1000-fund-passcode-banner.0a84333f.jpg";